(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["crossfade-slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('crossfade-slideshow')) {
    customElements.define('crossfade-slideshow', class extends HTMLElement {
      connectedCallback() {
        this.slides = [...this.querySelectorAll('.xfade__slide')];
        if (this.slides.length < 2) return;

        this.index = 0;
        this.delay = parseInt(this.dataset.interval, 10) || 5000;
        this.visible = false;
        this.editing = false;

        // Theme editor: jump to the selected block and hold it there
        this.addEventListener('shopify:block:select', (e) => {
          const i = this.slides.indexOf(e.target);
          if (i < 0) return;
          this.editing = true;
          this.pause();
          this.show(i);
        });
        this.addEventListener('shopify:block:deselect', () => {
          this.editing = false;
          this.play();
        });

        // Respect reduced motion: stay on the first image
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

        // Only run while on screen and the tab is visible
        this.io = new IntersectionObserver(([entry]) => {
          this.visible = entry.isIntersecting;
          this.visible ? this.play() : this.pause();
        });
        this.io.observe(this);

        this.onVisibility = () => (document.hidden ? this.pause() : this.play());
        document.addEventListener('visibilitychange', this.onVisibility);
      }

      disconnectedCallback() {
        this.pause();
        this.io?.disconnect();
        if (this.onVisibility) document.removeEventListener('visibilitychange', this.onVisibility);
      }

      show(i) {
        if (i === this.index) return;
        const current = this.slides[this.index];
        this.slides.forEach((s) => s.classList.remove('is-prev'));
        current.classList.remove('is-active');
        current.classList.add('is-prev');
        this.index = i;
        this.slides[i].classList.add('is-active');
      }

      next() {
        const i = (this.index + 1) % this.slides.length;
        const img = this.slides[i].querySelector('img');
        // Skip this tick if the next image isn't loaded yet, so it never fades in blank
        if (img && !img.complete) return;
        this.show(i);
      }

      play() {
        if (this.timer || this.editing || !this.visible || document.hidden) return;
        this.timer = setInterval(() => this.next(), this.delay);
      }

      pause() {
        clearInterval(this.timer);
        this.timer = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
